var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.51H3.75C3.33579 14.51 3 14.8458 3 15.26C3 15.6742 3.33579 16.01 3.75 16.01H7.25C7.93647 16.01 8.49451 16.5636 8.5 17.25V20.75C8.5 21.1642 8.83579 21.5 9.25 21.5C9.66421 21.5 10 21.1642 10 20.75V17.25C9.99449 15.7351 8.76489 14.51 7.25 14.51Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 14.51H17.25C15.7351 14.51 14.5055 15.7351 14.5 17.25V20.75C14.5 21.1642 14.8358 21.5 15.25 21.5C15.6642 21.5 16 21.1642 16 20.75V17.25C16.0055 16.5636 16.5635 16.01 17.25 16.01H20.75C21.1642 16.01 21.5 15.6742 21.5 15.26C21.5 14.8458 21.1642 14.51 20.75 14.51Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.01H20.75C21.1642 10.01 21.5 9.67421 21.5 9.26C21.5 8.84579 21.1642 8.51 20.75 8.51H17.25C16.9167 8.51001 16.5973 8.37694 16.3626 8.14036C16.1279 7.90377 15.9973 7.58325 16 7.25V3.75C16 3.33579 15.6642 3 15.25 3C14.8358 3 14.5 3.33579 14.5 3.75V7.25C14.4973 7.98108 14.7859 8.68312 15.3019 9.20101C15.8179 9.7189 16.5189 10.01 17.25 10.01Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3C8.83804 3.00539 8.50539 3.33804 8.5 3.75V7.25C8.50267 7.58325 8.37215 7.90377 8.13744 8.14036C7.90273 8.37694 7.58326 8.51001 7.25 8.51H3.75C3.33579 8.51 3 8.84579 3 9.26C3 9.67421 3.33579 10.01 3.75 10.01H7.25C7.98108 10.01 8.68208 9.7189 9.19809 9.20101C9.7141 8.68312 10.0027 7.98108 10 7.25V3.75C9.99462 3.33804 9.66196 3.00539 9.25 3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/Minimize.6d82970bbf3f7d1078c32e84b686156e.svg";
export { ForwardRef as ReactComponent };